






































































































import {Vue, Component} from 'vue-property-decorator';
import {mapGetters, mapActions} from 'vuex';
import PeriodPickerContainer from '@/components/PeriodPickerContainer';
import DateMixins from '@/core/dateMixins';

@Component({
  name: 'SearchingPanel',
  components: { PeriodPickerContainer },
  mixins: [DateMixins],
  props: {
    headerText: {
      type: String,
      default: '',
    },
    datepickerText: {
      type: String,
      default: '',
    },
    dateStart: {
      type: String,
      default: '',
    },
    period: {
      type: Object,
      default: () => {},
    },
    rooms: {
      type: Object,
      default: () => {},
    },
    btnText: {
      type: String,
      default: '',
    },
    datePickerActive: {
      type: Boolean,
      default: false,
    },
    mobileBtnText: {
      type: String,
      default: '',
    },
    choosePeriodText: {
      type: String,
      default: '',
    },
    minTermText: {
      type: String,
      default: '',
    },
    mobPeriodTitle: {
      type: String,
      default: '',
    },
    homePage: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      endDate: null,
      pickPeriod: null,
      mobileWidth: false,
      // minDay: this.$dayjs(new Date()).add(2, 'day').toISOString().substring(0, 10),
      minDay: this.$dayjs(new Date()).toISOString().substring(0, 10),
      modal: false,
      showDatePicker: false,
      countersButtonBlock: true,
    };
  },
  created() {
    this.onResize();
    document.addEventListener('click', this.clickOnPage);
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener('click', this.clickOnPage);
    window.removeEventListener('resize', this.onResize);
  },
  watch: {
    datePickerActive(val) {
      if (val) {
        this.$emit('toggleDatePickerActive');
      }
    },
  },
  computed: {
    ...mapGetters([
      'searchingPanelState',
      'language',
    ]),
    maxDay() {
      // return this.$dayjs(new Date()).add(2, 'month').add(2, 'day').toISOString().substring(0, 10);
      return this.$dayjs(new Date()).add(2, 'month').toISOString().substring(0, 10);
    },
    actualState: {
      get() {
        return this.searchingPanelState.startDate;
      },
      set(value) {
        this.setStartDate(value);
      },
    },
    actualRooms: {
      get() {
        return this.searchingPanelState.actualNumbersRooms;
      },
      set(value) {
        this.actualNumbersRooms(value);
      },
    },
    actualMonthsAdd: {
      get() {
        return this.searchingPanelState.monthsAdd;
      },
      set(value) {
        this.monthsAdd(value);
      },
    },
    actualYearsAdd: {
      get() {
        return this.searchingPanelState.yearsAdd;
      },
      set(value) {
        this.yearsAdd(value);
      },
    },
    dateBlock() {
      return this.$refs.dateBlock;
    },
    datePickerDomBlock() {
      return (this.$refs.datePickerBlock as Vue)?.$el;
    },
    periodBlock() {
      return this.$refs.periodBlock;
    },
    formattedActualDate() {
      return this.$dayjs(this.actualState).format('DD.MM.YY');
    },
  },
  methods: {
    ...mapActions([
      'setStartDate',
      'actualNumbersRooms',
      'monthsAdd',
      'yearsAdd',
    ]),
    searchApartment() {
      const data = {
        start: this.actualState,
        end: this.endDate,
        rooms: this.actualRooms.length > 0 ? this.actualRooms : (this as any).rooms.value,
      };
      this.$emit('sendSearchingData', data);
    },

    clickOnPage(e) {
      if (this.showDatePicker
        && e.target.id !== 'date-block'
        && e.target.parentElement.id !== 'date-block'
        && !this.dateBlock.contains(e.target)
        && this.datePickerDomBlock
        && !this.datePickerDomBlock.contains(e.target)) {
        this.showDatePicker = !this.showDatePicker;
      }
    },

    toggleRoom(e) {
      const newActualRooms = this.actualRooms;
      const elNumberOfRoom = e.target.classList.contains('room-item') ? e.target : e.target.parentElement;
      const numberElement = newActualRooms.indexOf(elNumberOfRoom.textContent);
      elNumberOfRoom.classList.toggle('active-room');
      numberElement === -1
        ? newActualRooms.push(elNumberOfRoom.textContent)
        : newActualRooms.splice(numberElement, 1);
      this.actualRooms = newActualRooms;
    },

    increasePeriod(name) {
        if (name === 'month' && this.actualMonthsAdd < 11) {
          this.actualMonthsAdd++;
        } else if ('month' && this.actualMonthsAdd === 11) {
          this.actualMonthsAdd = 0;
          this.actualYearsAdd++;
        } else if (name === 'year' && this.actualYearsAdd === 2) {
          this.actualMonthsAdd = 0;
          this.actualYearsAdd ++;
        } else if (name === 'year') {
          this.actualYearsAdd ++;
        }
    },

    decreasePeriod(name) {
      if (name === 'year' && this.actualYearsAdd === 1) {
        this.actualYearsAdd--;
        this.actualMonthsAdd = 6;
      } else if (name === 'year') {
        this.actualYearsAdd--;
      } else if (name === 'month') {
        this.actualMonthsAdd--;
      }
    },

    onResize() {
      this.mobileWidth = window.innerWidth < 1024;
    },

    activatePeriod(type, period) {
      if (type === 'month') {
        this.actualMonthsAdd = period;
        this.actualYearsAdd = 0;
      } else {
        this.actualMonthsAdd = 0;
        this.actualYearsAdd = period;
      }
    },

  },
})
export default class SearchingPanel extends Vue {
}
